import Content from '../../../components/combinationSetting/storeGroupsDialog/content';

export default function StoreGroupsDialogContainer(props) {
  const {
    open,
    onClose,
    mode,
    onSubmit,
    divisions1,
    divisions2,
    divisions3,
    areaCode,
  } = props;

  // ここにAPIを記述

  return (
    <Content
      mode={mode}
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      divisions1={divisions1}
      divisions2={divisions2}
      divisions3={divisions3}
      areaCode={areaCode}
    />
  );
}
